import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const AddContact = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <circle cx="9.5" cy="6.5" r="4.5" fill={getColor(color, isColorInherited)} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 22C19.7614 22 22 19.7614 22 17C22 14.2386 19.7614 12 17 12C14.2386 12 12 14.2386 12 17C12 19.7614 14.2386 22 17 22ZM18 15C18 14.4477 17.5523 14 17 14C16.4477 14 16 14.4477 16 15V16H15C14.4477 16 14 16.4477 14 17C14 17.5523 14.4477 18 15 18H16V19C16 19.5523 16.4477 20 17 20C17.5523 20 18 19.5523 18 19V18H19C19.5523 18 20 17.5523 20 17C20 16.4477 19.5523 16 19 16H18V15Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1011 22C10.8045 20.7295 10.0001 18.9587 10.0001 17C10.0001 15.0695 10.7815 13.3216 12.0453 12.0552C11.8287 12.0189 11.6064 12 11.3801 12H7.62001C5.565 12 3.84434 13.5572 3.63986 15.602L3.21996 19.801C3.10222 20.9784 4.02679 22 5.21003 22H12.1011Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
